const chips = ["10", "100", "1K", "5K", "10K"];

const drawStatus = {
    open: 0,
    drawing: 1,
    released: 2,
}

const currencyTypes = {
    khr: "KHR",
    usd: "USD",
    th: "TH"
}

export {chips, drawStatus, currencyTypes}